function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { createHashHistory } from "history";
import { Switch, Router, Route } from "react-router-dom";
// Limitless imports
import Screen from "@limitless/portal/components/screen/Screen";
import { setupAxiosInterceptors } from "@limitless/portal/utils/SecurePlatformAPIUtils";
import { useExpertProfileContext } from "@limitless/expert/hooks/expert-profile/ExpertProfileContext";
import { useAuthenticationContext } from "@limitless/expert/hooks/authentication/AuthenticationContext";
export const history = createHashHistory();
const RouteCreator = ({
  isHistoryEnabled,
  isPrivateRoute,
  navItems,
  rootComponent,
  mfaComponent,
  appContext,
  contactUsComponent,
  ...rest
}) => {
  const {
    canUserAccess
  } = useExpertProfileContext();
  const {
    signOut
  } = useAuthenticationContext();
  React.useEffect(() => {
    if (isPrivateRoute) {
      setupAxiosInterceptors(() => {
        signOut("Your session has expired");
      });
    }
  }, []);
  const getRouteComponent = comp => {
    if (!comp) {
      return comp;
    }
    if (comp.prototype instanceof PureComponent) {
      return comp;
    }
    if (typeof comp === "function") {
      return props => comp({
        navItems,
        ...props
      });
    }
    return comp;
  };
  const applicationBasedRoutes = () => {
    return navItems.map((navItem, navIndex) => {
      const routes = [];
      const allowAccess = navItem.policy ? canUserAccess(navItem.policy) : true;
      navItem.allowAccess = allowAccess;
      //wrap all our screens in the Require Auth Higher Order Component
      if (navItem.path !== null && allowAccess) {
        routes.push(/*#__PURE__*/React.createElement(Route, {
          exact: true,
          key: navIndex,
          path: navItem.path,
          component: getRouteComponent(navItem.component)
        }));
      }
      if (navItem.childRoutes) {
        navItem.childRoutes.map((childNav, index) => {
          const allowChildAccess = childNav.policy ? canUserAccess(childNav.policy) : true;
          childNav.allowAccess = allowChildAccess;
          if (childNav.path !== null && allowChildAccess) {
            routes.push(/*#__PURE__*/React.createElement(Route, {
              exact: true,
              key: index + 100,
              path: childNav.path,
              component: getRouteComponent(childNav.component)
            }));
          }
        });
      }
      return routes;
    });
  };
  const withoutHistoryRoutes = () => {
    return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/",
      component: rootComponent
    }), /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/mfa-setup",
      component: mfaComponent
    }), rest.screenProps.mode === "expert" && /*#__PURE__*/React.createElement(Route, {
      exact: true,
      path: "/contact-us",
      component: contactUsComponent
    }), isPrivateRoute ? /*#__PURE__*/React.createElement(Screen, _extends({}, rest.screenProps, {
      history: history,
      navItems: navItems
    }), appContext ? appContext(applicationBasedRoutes()) : applicationBasedRoutes()) : applicationBasedRoutes());
  };
  return isHistoryEnabled ? /*#__PURE__*/React.createElement(Router, {
    history: history
  }, withoutHistoryRoutes()) : withoutHistoryRoutes();
};
export default RouteCreator;
RouteCreator.propTypes = {
  isHistoryEnabled: PropTypes.bool,
  isPrivateRoute: PropTypes.bool,
  rootComponent: PropTypes.func,
  mfaComponent: PropTypes.func,
  navItems: PropTypes.array,
  appContext: PropTypes.func,
  contactUsComponent: PropTypes.func
};
RouteCreator.defaultProps = {
  isHistoryEnabled: true,
  isPrivateRoute: true,
  navItems: []
};